module.exports = __webpack_public_path__ + "static/media/lightning-1.055aad41.svg";